import axios from "axios";

const postDiagnosis = async (baseUrl, token, doctorId, appointmentId, diagnosis) => {

    const config = {
        headers: { Authorization: `Bearer ${token}` }
    };

    let postResponse = null

    await axios.post(baseUrl + "/doctor/" + doctorId + "/appointment/" + appointmentId + "/diagnosis/", diagnosis, config)
        .then((res) => {
            postResponse = {
                status: res.status,
                data: res.data
            }
        }).catch((error) => {
            if (error.response !== undefined) {
                postResponse = {
                    status: error.response.status,
                    data: error.response.status
                }
            }
        });
    return postResponse
}

export default postDiagnosis;
